// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/hero-1/module';
import './modules/theme/hero-usp/module';
import './modules/theme/banner-usp/module';
import './modules/theme/brands-3/module';
import './modules/theme/info-cards/module';
import './modules/theme/testimonials/module';
import './modules/theme/category-section-2/module';
import './modules/theme/how-it-works/module';
import './modules/theme/vertical-carousels/module';
import './modules/theme/usp-strip/module';
import './modules/theme/video-widget/module';
import './modules/theme/trigger-action/module';

// layouts

// leave me last
import './js/base/base-end';
